module.exports = __webpack_public_path__ + "assets/img/enterprise2.b0231208.png";